"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * Edit table with given operation. If there is no table at cursor then no op.
 * @param editor The editor instance
 * @param operation Table operation
 */
function editTable(editor, operation) {
    var td = editor.getElementAtCursor('TD,TH');
    if (td) {
        editor.addUndoSnapshot(function (start, end) {
            var vtable = new roosterjs_editor_dom_1.VTable(td);
            vtable.edit(operation);
            vtable.writeBack();
            editor.focus();
            var cellToSelect = calculateCellToSelect(operation, vtable.row, vtable.col);
            editor.select(vtable.getCell(cellToSelect.newRow, cellToSelect.newCol).td, 0 /* Begin */);
        }, "Format" /* Format */);
    }
}
exports.default = editTable;
function calculateCellToSelect(operation, currentRow, currentCol) {
    var newRow = currentRow;
    var newCol = currentCol;
    switch (operation) {
        case 0 /* InsertAbove */:
            newCol = 0;
            break;
        case 1 /* InsertBelow */:
            newRow += 1;
            newCol = 0;
            break;
        case 2 /* InsertLeft */:
            newRow = 0;
            break;
        case 3 /* InsertRight */:
            newRow = 0;
            newCol += 1;
            break;
    }
    return {
        newRow: newRow,
        newCol: newCol,
    };
}
//# sourceMappingURL=editTable.js.map